/* Dog Socky - Sizing Widget | rasnamen DE/FR (NL/EN staan in sizing-widget.js).
   Gekoppeld via breed-id. De widget kiest de naam via window.DSW_LOCALE (fallback en/nl). */
window.DSW_BREED_I18N = {
  chihuahua:{de:'Chihuahua',fr:'Chihuahua'},
  yorkie:{de:'Yorkshire Terrier',fr:'Yorkshire Terrier'},
  pom:{de:'Zwergspitz',fr:'Spitz nain'},
  toypoedel:{de:'Toypudel',fr:'Caniche toy'},
  maltese:{de:'Malteser',fr:'Bichon maltais'},
  minpin:{de:'Zwergpinscher',fr:'Pinscher nain'},
  russiantoy:{de:'Russkiy Toy',fr:'Petit chien russe'},
  jackrussell:{de:'Jack Russell Terrier',fr:'Jack Russell Terrier'},
  teckel:{de:'Dackel',fr:'Teckel'},
  bichon:{de:'Bichon Frisé',fr:'Bichon frisé'},
  shihpoo:{de:'Shih-Poo',fr:'Shih-Poo'},
  papillon:{de:'Papillon',fr:'Épagneul papillon'},
  westie:{de:'West Highland Terrier',fr:'West Highland Terrier'},
  kingcharles:{de:'King Charles Spaniel',fr:'King Charles Spaniel'},
  cairn:{de:'Cairn Terrier',fr:'Cairn Terrier'},
  shihtzu:{de:'Shih Tzu',fr:'Shih Tzu'},
  frenchbull:{de:'Französische Bulldogge',fr:'Bouledogue français'},
  cavalier:{de:'Cavalier King Charles',fr:'Cavalier King Charles'},
  pug:{de:'Mops',fr:'Carlin'},
  beagle:{de:'Beagle',fr:'Beagle'},
  cocker:{de:'Cocker Spaniel',fr:'Cocker Spaniel'},
  sheltie:{de:'Shetland Sheepdog',fr:'Berger des Shetland'},
  minischnauzer:{de:'Zwergschnauzer',fr:'Schnauzer nain'},
  minipoedel:{de:'Zwergpudel',fr:'Caniche nain'},
  corgi:{de:'Welsh Corgi',fr:'Welsh Corgi'},
  whippet:{de:'Whippet',fr:'Whippet'},
  scottish:{de:'Scottish Terrier',fr:'Scottish Terrier'},
  engbull:{de:'Englische Bulldogge',fr:'Bouledogue anglais'},
  cotontulear:{de:'Coton de Tuléar',fr:'Coton de Tuléar'},
  havanese:{de:'Havaneser',fr:'Bichon havanais'},
  springerspaniel:{de:'Springer Spaniel',fr:'Springer Spaniel'},
  americancocker:{de:'Amerikanischer Cocker Spaniel',fr:'Cocker américain'},
  bostonterrier:{de:'Boston Terrier',fr:'Boston Terrier'},
  lagotto:{de:'Lagotto Romagnolo',fr:'Lagotto Romagnolo'},
  welshspringer:{de:'Welsh Springer Spaniel',fr:'Welsh Springer Spaniel'},
  corgicardigan:{de:'Welsh Corgi Cardigan',fr:'Welsh Corgi Cardigan'},
  basenji:{de:'Basenji',fr:'Basenji'},
  stdschnauzer:{de:'Mittelschnauzer',fr:'Schnauzer moyen'},
  portwater:{de:'Portugiesischer Wasserhund',fr:'Chien d\'eau portugais'},
  boykin:{de:'Boykin Spaniel',fr:'Boykin Spaniel'},
  pon:{de:'Polnischer Niederungshütehund',fr:'Berger polonais de plaine'},
  border:{de:'Border Collie',fr:'Border Collie'},
  dalmatian:{de:'Dalmatiner',fr:'Dalmatien'},
  aussie:{de:'Australian Shepherd',fr:'Berger australien'},
  malinois:{de:'Malinois',fr:'Malinois'},
  dobermann:{de:'Dobermann',fr:'Dobermann'},
  grootepoedel:{de:'Großpudel',fr:'Caniche royal'},
  siberianhusky:{de:'Siberian Husky',fr:'Husky de Sibérie'},
  airedale:{de:'Airedale Terrier',fr:'Airedale Terrier'},
  irishsetter:{de:'Irish Setter',fr:'Setter irlandais'},
  flatcoated:{de:'Flat Coated Retriever',fr:'Flat Coated Retriever'},
  weimaraner:{de:'Weimaraner',fr:'Braque de Weimar'},
  boxer:{de:'Boxer',fr:'Boxer'},
  viszla:{de:'Magyar Vizsla',fr:'Braque hongrois'},
  greyhound:{de:'Greyhound',fr:'Lévrier'},
  amstaff:{de:'American Staffordshire Terrier',fr:'American Staffordshire Terrier'},
  toller:{de:'Nova Scotia Retriever',fr:'Retriever de la Nouvelle-Écosse'},
  hollandsherder:{de:'Hollandse Herder',fr:'Berger hollandais'},
  groenendael:{de:'Groenendael',fr:'Groenendael'},
  laekenois:{de:'Laekenois',fr:'Laekenois'},
  gsp:{de:'Deutsch Kurzhaar',fr:'Braque allemand'},
  gwp:{de:'Deutsch Drahthaar',fr:'Braque allemand à poil dur'},
  englishsetter:{de:'English Setter',fr:'Setter anglais'},
  clumber:{de:'Clumber Spaniel',fr:'Clumber Spaniel'},
  sharpei:{de:'Shar Pei',fr:'Shar Peï'},
  bassethound:{de:'Basset Hound',fr:'Basset Hound'},
  kelpie:{de:'Australian Kelpie',fr:'Kelpie australien'},
  acd:{de:'Australian Cattle Dog',fr:'Bouvier australien'},
  wss:{de:'Weißer Schweizer Schäferhund',fr:'Berger blanc suisse'},
  gordonsetter:{de:'Gordon Setter',fr:'Setter Gordon'},
  samojeed:{de:'Samojede',fr:'Samoyède'},
  kees:{de:'Wolfsspitz',fr:'Spitz loup'},
  chow:{de:'Chow-Chow',fr:'Chow-chow'},
  stafie:{de:'Staffordshire Bullterrier',fr:'Staffordshire Bull Terrier'},
  borderterrier:{de:'Border Terrier',fr:'Border Terrier'},
  tervueren:{de:'Tervueren',fr:'Tervueren'},
  labrador:{de:'Labrador Retriever',fr:'Labrador Retriever'},
  golden:{de:'Golden Retriever',fr:'Golden Retriever'},
  gsd:{de:'Deutscher Schäferhund',fr:'Berger allemand'},
  ridgeback:{de:'Rhodesian Ridgeback',fr:'Rhodesian Ridgeback'},
  akita:{de:'Akita',fr:'Akita Inu'},
  hovawart:{de:'Hovawart',fr:'Hovawart'},
  chesapeake:{de:'Chesapeake Bay Retriever',fr:'Chesapeake Bay Retriever'},
  dogo:{de:'Dogo Argentino',fr:'Dogue argentin'},
  cane:{de:'Cane Corso',fr:'Cane Corso'},
  curlycoated:{de:'Curly Coated Retriever',fr:'Curly Coated Retriever'},
  oes:{de:'Bobtail',fr:'Bobtail'},
  briard:{de:'Briard',fr:'Briard'},
  giantschnauzer:{de:'Riesenschnauzer',fr:'Schnauzer géant'},
  spinone:{de:'Spinone Italiano',fr:'Spinone italien'},
  americanbulldog:{de:'Amerikanische Bulldogge',fr:'Bouledogue américain'},
  oeb:{de:'Olde English Bulldogge',fr:'Olde English Bulldogge'},
  berner:{de:'Berner Sennenhund',fr:'Bouvier bernois'},
  rottweiler:{de:'Rottweiler',fr:'Rottweiler'},
  newfie:{de:'Neufundländer',fr:'Terre-Neuve'},
  stbernard:{de:'Bernhardiner',fr:'Saint-Bernard'},
  greatdane:{de:'Deutsche Dogge',fr:'Dogue allemand'},
  leonberger:{de:'Leonberger',fr:'Leonberg'},
  bouvier:{de:'Bouvier des Flandres',fr:'Bouvier des Flandres'},
  mastiff:{de:'Englischer Mastiff',fr:'Mastiff'},
  malamute:{de:'Alaskan Malamute',fr:'Malamute de l\'Alaska'},
  boerboel:{de:'Boerboel',fr:'Boerboel'},
  irishwolf:{de:'Irischer Wolfshund',fr:'Lévrier irlandais'},
  bullmastiff:{de:'Bullmastiff',fr:'Bullmastiff'},
  bloodhound:{de:'Bluthund',fr:'Chien de Saint-Hubert'},
  anatolian:{de:'Anatolischer Hirtenhund',fr:'Berger d\'Anatolie'},
  kangal:{de:'Kangal',fr:'Kangal'},
  kuvasz:{de:'Kuvasz',fr:'Kuvasz'},
  greatpyrenees:{de:'Pyrenäenberghund',fr:'Montagne des Pyrénées'},
  deerhound:{de:'Deerhound',fr:'Lévrier écossais'},
  landseer:{de:'Landseer',fr:'Landseer'},
  bordeaux:{de:'Bordeauxdogge',fr:'Dogue de Bordeaux'},
  shibainu:{de:'Shiba Inu',fr:'Shiba Inu'},
  stabyhoun:{de:'Stabyhoun',fr:'Stabyhoun'},
  kooiker:{de:'Kooikerhondje',fr:'Kooikerhondje'},
  bullterrier:{de:'Bullterrier',fr:'Bull Terrier'}
};
